/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpInstructions from './pre-op-instructions';
import PreOpInstructionsDetail from './pre-op-instructions-detail';
import PreOpInstructionsUpdate from './pre-op-instructions-update';
import PreOpInstructionsDeleteDialog from './pre-op-instructions-delete-dialog';

const PreOpInstructionsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpInstructions />} />
    <Route path="new" element={<PreOpInstructionsUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpInstructionsDetail />} />
      <Route path="edit" element={<PreOpInstructionsUpdate />} />
      <Route path="delete" element={<PreOpInstructionsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpInstructionsRoutes;
